var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrueAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9167 29.9987L6.41669 20.4987L8.79169 18.1237L15.9167 25.2487L31.2084 9.95703L33.5834 12.332L15.9167 29.9987Z",
    fill: "#273848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueAnalysis);
export default __webpack_public_path__ + "static/media/trueAnalysis.aa5747bb63b7926fa5be5aa2b0bbcbc4.svg";
export { ForwardRef as ReactComponent };